module.exports = __webpack_public_path__ + "media/svg/symbols-4864cd9a.svg";